import email from "../assets/email.png";
import envelope from "../assets/envelope.jpg";
import mobile from "../assets/mobile.png";
import api from "../assets/api.png";
import cpp from "../assets/cpp.png";
import css from "../assets/css.png";
import figma from "../assets/figma.png";
import flutter from "../assets/flutter.png";
import git from "../assets/git.png";
import graphql from "../assets/graphql.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import mu5 from "../assets/mu5.png";
import node from "../assets/node.png";
import python from "../assets/python.png";
import react from "../assets/react.png";
import redux from "../assets/redux.png";
import sass from "../assets/sass.png";
import typescript from "../assets/typescript.png";
import vue from "../assets/vue.png";
import elementUI from '../assets/elementUI.png'
import quasar from '../assets/quasar.png'
import vuex from '../assets/vuex.png'

import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";

import profile from "../assets/profile.png";
import profile1 from "../assets/profile1.png";
import profile2 from "../assets/profile2.png";
import profile3 from "../assets/profile3.png";
import profile4 from "../assets/profile4.png";
import profile5 from "../assets/profile5.png";
import marina from "../assets/marina.jpg"
import stefania from "../assets/stefania.jpg"
import sebi from "../assets/sebi.jpg"

import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";
import logoIonut from "../assets/LogoIonut.png";

import adidas from "../assets/adidas.png";
import amazon from "../assets/amazon.png";
import asus from "../assets/asus.png";
import bolt from "../assets/bolt.png";
import nb from "../assets/nb.png";
import skype from "../assets/skype.png";
import spotify from "../assets/spotify.png";

import movieSite from "../assets/movieSite.jpg"
import minesweeper from "../assets/minesweeper.jpg"
import taskTracker from "../assets/taskTracker.png"
import snake from "../assets/snake.jpg"
import massageSite from "../assets/massageSite.png"
import onlineStore from "../assets/onlineStore.png"


export default {
  email,
  envelope,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  vuex, 
  elementUI,
  quasar,
  about01,
  about02,
  about03,
  about04,
  profile,
  profile1,
  profile2,
  profile3,
  profile4,
  profile5,
  marina,
  stefania,
  sebi,
  circle,
  logo,
  logoIonut,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
  movieSite,
  onlineStore,
  minesweeper,
  taskTracker,
  snake,
  massageSite
};
